import * as Yup from "yup";

export const initialValues = {
  code: null,
  name: null,
  nameEn: null,
  incomeType: null,
  rounding: null,
  frequencyOfPayment: null,
};

const EmploymentTypeSchema = Yup.object().shape({
  employmentTypeName: Yup.string().required("Please enter employment type name."),
  payMentType: Yup.string().required("Please enter payment type."),
  thisEmploymentIncomeTypeSetting: Yup.string().required("Please select Y"),
  incomes: Yup.array().min(1, 'Please select at least one income').required('please select incomes'),
  deductions: Yup.array().min(1, 'Please select at least one deductions').required('please select deductions'),

  // daysForDividing: Yup.string().required("Please enter days for dividing."),
  // daysForMultiplying: Yup.string().required("Please enter days for multiplying."),
  // overtimePerHour: Yup.string().required("Please enter overtime per hour."),
  // overtimeDuringShiftOnHoliday: Yup.string().required("Please enter overtime during shift on holiday."),
  // overtimeDuringShiftOnTraditionalHoliday: Yup.string().required("Please enter overtime during shift on traditional holiday."),
  // overtimeOnWorkdays: Yup.string().required("Please enter overtime on workdays."),
  // overtimeOutsideShiftOnHoliday: Yup.string().required("Please enter overtime outside shift on holiday."),
  // overtimeOutsideShiftOnTraditionalHoliday: Yup.string().required("Please enter overtime outside shift on traditional holiday."),
  // amountDeducted: Yup.string().when("calculateDeductionBy", {
  //   is: (val) => val === "Custom",
  //   then: () =>
  //     Yup.string().required(
  //       "Please enter your amount deducted in late."
  //     ),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
  // amountDeductedPerDayNoTimestamp: Yup.string().when("calculateDeductionByNoTimestamp", {
  //   is: (val) => val === "Custom",
  //   then: () =>
  //     Yup.string().required(
  //       "Please enter your amount deducted per day."
  //     ),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
  // amountDeductedPerDayLateWorkIn: Yup.string().when("calculateDeductionByLateWorkIn", {
  //   is: (val) => val === "Custom",
  //   then: () =>
  //     Yup.string().required(
  //       "Please enter your amount deducted per day."
  //     ),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
});

export default EmploymentTypeSchema;
